export default __webpack_public_path__ + "static/media/welcome-background.0bb37d91.png";